import { Spin } from "antd"

const LoaderComponents = () => {
    return (
        <div style={{
            width: "100%",
            height: "100%"
        }}>
            <Spin fullscreen />
        </div>
    )
}

export default LoaderComponents;